import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const VehicleImg = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutralDark100};

    border-radius: 8px;
    margin-right: 16px;

    height: 56px;
    width: 56px;

    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

export const Img = styled.img``;

export const VehicleContent = styled.div``;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark40};
    font-size: 1.4rem;
    margin-bottom: 4px;
    display: block;
  `}
`;

export const Value = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark90};
    font-size: 2.4rem;
    font-weight: 700;
  `}
`;
